import type { CSSProperties, HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

interface Props extends Omit<HTMLAttributes<HTMLOutputElement>, 'role' | 'aria-label'> {
  readonly width?: string | number;
  readonly height?: string | number;
  readonly rounded?: string | number;
  readonly ariaLabel?: string;
}

function dim(value: string | number | undefined, fallback: string) {
  if (value === undefined) return fallback;
  return typeof value === 'number' ? `${value}px` : value;
}

export function Skeleton({
  width,
  height,
  rounded,
  ariaLabel = 'Loading',
  className,
  style,
  ...rest
}: Readonly<Props>) {
  const merged: CSSProperties = {
    display: 'block',
    width: dim(width, '100%'),
    height: dim(height, '1rem'),
    borderRadius: dim(rounded, '0.25rem'),
    ...style,
  };
  return (
    <output
      aria-label={ariaLabel}
      aria-busy="true"
      className={cn('orb-skeleton', className)}
      style={merged}
      {...rest}
    />
  );
}
